Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('react');
const eventDefinitions = require('./event-definitions.js');
const types = require('./types.js');

const useChatStatus = () => {
    const [status, setStatus] = react.useState(getInitialStatus());
    react.useEffect(() => {
        function handleStatusChange(event) {
            setStatus(event.detail.status);
        }
        document.addEventListener(eventDefinitions.CUSTOM_EVENTS.CHAT_STATUS_CHANGED, handleStatusChange);
        return () => {
            document.removeEventListener(eventDefinitions.CUSTOM_EVENTS.CHAT_STATUS_CHANGED, handleStatusChange);
        };
    }, []);
    return status;
};
function transformMetadataContext(metadataContext) {
    if (!metadataContext || typeof metadataContext !== 'object') {
        throw new Error('Invalid metadataContext provided');
    }
    return Object.entries(metadataContext).reduce((acc, [key, value]) => {
        acc[`context_${key}`] = value;
        return acc;
    }, {});
}
function triggerChat(triggerName, metadataContext) {
    if (!triggerName) {
        throw new Error('source name must be provided to trigger a chat');
    }
    const transformedMetadataContext = metadataContext ? transformMetadataContext(metadataContext) : undefined;
    document.dispatchEvent(new CustomEvent(eventDefinitions.CUSTOM_EVENTS.CHAT_REQUEST, {
        detail: {
            triggerName,
            metadataContext: transformedMetadataContext,
        },
    }));
}
function getInitialStatus() {
    return window.__CHAT_STATUS || types.SessionStatus.Idle;
}

Object.defineProperty(exports, 'CUSTOM_EVENTS', {
enumerable: true,
get: () => eventDefinitions.CUSTOM_EVENTS
});
Object.defineProperty(exports, 'ChatSourceName', {
enumerable: true,
get: () => types.ChatSourceName
});
Object.defineProperty(exports, 'SessionStatus', {
enumerable: true,
get: () => types.SessionStatus
});
exports.triggerChat = triggerChat;
exports.useChatStatus = useChatStatus;
